/**
 * Shared base64 / base64url encoding helpers.
 *
 * These are pure-TS utilities with no Web Crypto dependency — safe to import
 * in any environment (browser, Node, extension service worker, Android via
 * the JS bridge).
 */

export function bytesToBase64(b: Uint8Array): string {
  let s = '';
  for (const c of b) s += String.fromCharCode(c);
  return btoa(s);
}

export function bytesToBase64Url(b: Uint8Array): string {
  return bytesToBase64(b).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function base64ToBytes(b64: string): Uint8Array {
  return Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
}

export function base64UrlToBytes(b64url: string): Uint8Array {
  const pad = b64url.length % 4 === 0 ? '' : '='.repeat(4 - (b64url.length % 4));
  return base64ToBytes((b64url + pad).replace(/-/g, '+').replace(/_/g, '/'));
}
